<template>
  <div>
    <div v-intersect.quiet="endIntersect" />
    <v-list-item class="list-filters__loading-item px-2">
      <v-progress-linear indeterminate color="primary" height="4" />
    </v-list-item>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AppLoadMoreLoader',

  methods: {
    endIntersect (entries: IntersectionObserverEntry[]) {
      if (!entries[0]?.isIntersecting) {
        return;
      }

      this.$emit('end:intersect');
    }
  }
})
</script>
